import type { FilterValue } from '@/components/Table/types';

export function getDefaultEvidenceFiltersForMapping(
  mappingContent: { name: string; selectedPmYear?: number } | undefined,
): FilterValue[] | undefined {
  if (!mappingContent) return undefined;

  if (mappingContent.name === 'numPMIDsupportingAssociation') {
    const base: FilterValue[] = [
      { name: 'reference_type', operator: 'contains', type: 'string', value: 'PMID' },
    ];
    if (mappingContent.selectedPmYear != null && Number.isFinite(Number(mappingContent.selectedPmYear))) {
      const y = Number(mappingContent.selectedPmYear);
      base.push({
        name: 'pmYear',
        operator: 'eq',
        type: 'number',
        integer: true,
        value: String(y),
      });
    }
    return base;
  }

  if (mappingContent.name === 'numCTsSupportingAssociation' || mappingContent.name === 'numCTs') {
    return [{ name: 'reference_type', operator: 'contains', type: 'string', value: 'NCTID' }];
  }

  return undefined;
}
